export default "__VITE_ASSET__CxFiCX6G__"